import React from "react";
import { DialogOverlay, DialogContent } from "@reach/dialog";

const DefaultModal = props => {
  const { isOpen, onHide, children, label = "modal", style = {}, className } = props;

  return (
    <DialogOverlay
      className={className}
      onDismiss={onHide}
      isOpen={isOpen}
    >
      <DialogContent style={{ ...style }} aria-label={label}>
        {
          React.Children.map(children, child => {
            return !child
              ? null
              : typeof child.type === 'string'
                ? child
                : React.cloneElement(child);
          })
        }
      </DialogContent>
    </DialogOverlay>
  );
};

export default DefaultModal;
